import Vue from 'vue';
import Clipboard from './clipboard';

Vue.directive('clipboard', Clipboard);
